import moment from 'moment';
import * as Yup from 'yup';

export const getEmployeeOnboardingSchema = (step: number) => {
  if (step === 1) {
    return Yup.object().shape({
      employeeId: Yup.string().required('Employee Id is required'),
      fullName: Yup.string().required('Full Name is required'),
      email: Yup.string()
        .email('Invalid email format')
        .matches(/^[a-zA-Z0-9](.*[a-zA-Z0-9])?$/, 'Invalid email format')
        .required('Email is required'),
      department: Yup.string().required('Department is required'),
      contact: Yup.string()
        .required('Contact is required')
        .matches(
          /^\+?[0-9\s\-()]{7,20}$/,
          'Contact must be a valid phone number',
        ),
      dob: Yup.date()
        .required('Date of Birth is required')
        .max(moment().toDate(), 'Date of Birth cannot be in the future'),

      dateOfHire: Yup.date()
        .required('Date of Hire is required')
        .min(Yup.ref('dob'), 'Date of Hire must be after Date of Birth'),
      jobTitle: Yup.string().required('Job Title is required'),
      role: Yup.string().required('Role is required'),
      // dob: Yup.string().required('Date of Birth is required'),
      // dateOfHire: Yup.string().required('Date of Hire is required'),
    });
  } else {
    return Yup.object();
  }
};
